module.exports = __webpack_public_path__ + "fonts/dmsans-bold-webfont.2dfe0ed.woff2";